import { render, staticRenderFns } from "./orderFormLegend.vue?vue&type=template&id=1df6e7df&lang=pug"
var script = {}
import style0 from "./orderFormLegend.vue?vue&type=style&index=0&id=1df6e7df&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports